import React from 'react';

export function LawPaidColumnFormatter(label, paidSoFar) {
  const getColor = () => {
    if (paidSoFar === 515) {
      return 'text-success'
    } else if (paidSoFar === 0 || paidSoFar > 515) {
      return 'text-danger'
    } else if (paidSoFar < 515) {
      return 'text-warning'
    } else return ''
  };
  return (
    <div
      className={`font-weight-bolder d-block font-size-lg text-nowrap ${getColor()}`}
    >
      {label}
    </div>
  );
}
